import React from 'react';
import { bookingShape } from 'constants/propTypes';
import { intlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import JourneyLeg from './JourneyLeg';
import { StyledDiv, StyledH2 } from './styles';

const JourneyDetails = ({ booking, intl }) => {
  const { outbound, inbound } = booking;
  const outboundLegs = outbound.map((leg) => <JourneyLeg key={leg.id} leg={leg} direction="outbound" intl={intl} />);
  const inboundLegs = inbound.map((leg) => <JourneyLeg key={leg.id} leg={leg} direction="inbound" intl={intl} />);
  return (
    <>
      <StyledH2>
        <FormattedMessage id="quoteConfirmation.journeyDetails.title" />
      </StyledH2>
      <StyledDiv>{outboundLegs.concat(inboundLegs)}</StyledDiv>
    </>
  );
};

JourneyDetails.propTypes = {
  booking: bookingShape.isRequired,
  intl: intlShape.isRequired
};

export default JourneyDetails;
